export const LIST_PROJECTS_START = 'LIST_PROJECTS_START';
export const LIST_PROJECTS_SUCCESS = 'LIST_PROJECTS_SUCCESS';
export const LIST_PROJECTS_ERROR = 'LIST_PROJECTS_ERROR';
export const LIST_PROJECTS_END = 'LIST_PROJECTS_END';
